import {
    getTestStory,
    regressionTest,
} from "../../../../test-utils/regression";

describe("ux-video", async () => {
    it("passes the regression test", async () => {
        await regressionTest({
            storyId: getTestStory("video", "video-with-controls"),
            componentTag: "ux-video",
            performActions: async (page) => {
                await page.evaluate(() => {
                    function waitForMedatada() {
                        new Promise((_, res) => {
                            const video = document.querySelector("video");
                            video.addEventListener("loadedmetadata", () =>
                                res()
                            );
                        });
                    }
                    waitForMedatada();
                });
                await page.waitForTimeout(1500);
            },
        });
    });
});
